export enum ContextSideNavigationType {
  DEFAULT = 'default',
  PRODUCTS = 'products',
  TEAM_REPORTS = 'team-reports',
  REPORTS = 'reports',
  WELLNESS_REPORTS = 'wellness-reports',
  RECORDER_REPORTS = 'recorder-reports',
}
